import React, { useCallback } from 'react';

import { Slider } from '../../Slider';
import { SimplifiedCard } from '../SimplifiedCard';
import { SIMPLIFIED_CARDS } from './cards';
import { Device } from '../utils/useMediaQuery';
import { trackSliderClick } from '../tracking/trackSliderClick';

import { EPageKind } from '../../../types/page';
import styles from './SimplifiedCards.css';

interface ISimplifiedCardsProps {
  pageKind: EPageKind;
  device: Device;
}

const SLIDER_CLASSES = {
  group: styles['slider-group'],
  groupsContainer: styles['slider-groups-container'],
};

const LaptopSimplifiedCards = (props: { pageKind: EPageKind }) => {
  const { pageKind } = props;

  const trackPrevButtonClick = useCallback(() => trackSliderClick({ pageKind, buttonType: 'prev' }), []);
  const trackNextButtonClick = useCallback(() => trackSliderClick({ pageKind, buttonType: 'next' }), []);

  return (
    <Slider
      visibleSlidesCount={3}
      step={3}
      classes={SLIDER_CLASSES}
      onPrevButtonClick={trackPrevButtonClick}
      onNextButtonClick={trackNextButtonClick}
    >
      {SIMPLIFIED_CARDS.map(card => (
        <SimplifiedCard key={card.title} className={styles['laptop-card']} pageKind={pageKind} {...card} />
      ))}
    </Slider>
  );
};

const DesktopSimplifiedCards = (props: { pageKind: EPageKind }) => {
  const { pageKind } = props;

  const trackPrevButtonClick = useCallback(() => trackSliderClick({ pageKind, buttonType: 'prev' }), []);
  const trackNextButtonClick = useCallback(() => trackSliderClick({ pageKind, buttonType: 'next' }), []);

  return (
    <Slider
      visibleSlidesCount={4}
      step={4}
      classes={SLIDER_CLASSES}
      onPrevButtonClick={trackPrevButtonClick}
      onNextButtonClick={trackNextButtonClick}
    >
      {SIMPLIFIED_CARDS.map(card => (
        <SimplifiedCard key={card.title} className={styles['desktop-card']} pageKind={pageKind} {...card} />
      ))}
    </Slider>
  );
};

export const SimplifiedCards = ({ pageKind, device }: ISimplifiedCardsProps) => {
  if (device === 'laptop') {
    return <LaptopSimplifiedCards pageKind={pageKind} />;
  }

  if (device === 'desktop') {
    return <DesktopSimplifiedCards pageKind={pageKind} />;
  }

  return null;
};
